import dynamic from 'next/dynamic';

export const Transition01 = dynamic(() => import('./Transition01'), {
  ssr: false,
});
